import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'

import { globalPDFStyles } from '../../styles'

type Props = {
  chartImage: string | null
}

export const chartPDFStyles = StyleSheet.create({
  container: {
    marginVertical: 20,
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#dee2e6',
    paddingTop: 12,
    paddingBottom: 10,
    paddingLeft: 12,
    paddingRight: 16,
  },
})

export const MeasuresPDFChart = ({ chartImage }: Props) => (
  <View style={chartPDFStyles.container}>
    <Text style={[globalPDFStyles.paragraphTitle, { marginBottom: 12 }]}>
      Chart
    </Text>
    {chartImage ? (
      <View>
        <Image src={chartImage} style={{ width: '100%' }} />
      </View>
    ) : null}
  </View>
)
